import { render, staticRenderFns } from "./menuEnterprise.vue?vue&type=template&id=5897650e&scoped=true&"
import script from "./menuEnterprise.vue?vue&type=script&lang=js&"
export * from "./menuEnterprise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5897650e",
  null
  
)

export default component.exports